module.exports = __webpack_public_path__ + "img/logo.7460be37.png";